/**
 * True when the surface's own upload hook would accept this file, so it is
 * worth framing. Anything else skips the editor and goes straight to the
 * hook, which refuses it locally exactly as before, and the editor never
 * decodes a huge or unsupported file. ISSUE-1094 plan Decision 7.
 */
export function shouldOpenCropEditor(input: {
  file: File;
  contentTypes: readonly string[];
  maxBytes: number;
}): boolean {
  return (
    input.contentTypes.includes(input.file.type) &&
    input.file.size >= 1 &&
    input.file.size <= input.maxBytes
  );
}
